// extracted by mini-css-extract-plugin
export default {"root":"CSLOGO_ColoredTrueTextTrueHori_root__VeTjg","layer3":"CSLOGO_ColoredTrueTextTrueHori_layer3__ZPa3G","icon":"CSLOGO_ColoredTrueTextTrueHori_icon__ZahR5"};